import { render, staticRenderFns } from "./merchant-config.vue?vue&type=template&id=b2a7499a&scoped=true&"
import script from "./merchant-config.vue?vue&type=script&lang=js&"
export * from "./merchant-config.vue?vue&type=script&lang=js&"
import style0 from "./merchant-config.vue?vue&type=style&index=0&id=b2a7499a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a7499a",
  null
  
)

export default component.exports